import React from "react";
import { Check, X } from "lucide-react";
import { JhText, JhTextProps } from "designPackages/textPackage";

type types = "perk" | "drawback";

interface listValue {
  type: types;
  value: string;
}

interface typographyProps extends JhTextProps {}

interface PerksDrawbackProps extends typographyProps {
  list: listValue[];
}

const PerksDrawback = ({
  list,
  variant = "body2"
}: PerksDrawbackProps): JSX.Element => {
  const renderIcon = (type: types): JSX.Element | null => {
    switch (type) {
      case "perk": {
        return (
          <Check
            color="var(--success-foreground)"
            size={"16"}
            strokeWidth={1.5}
            className="mr-1 relative sm:top-[0px] top-[2px]"
          />
        );
      }
      case "drawback": {
        return <X color="var(--destructive)" size={"16"} strokeWidth={1.5} className="mr-1 relative sm:top-[0px] top-[2px]" />;
      }
      default: {
        return null;
      }
    }
  };
  return (
    <ul className="flex text-left flex-col gap-y-2 sm:gap-y-2.5">
      {list.map((item, index) => {
        return (
          <JhText
            className="flex sm:items-center items-start"
            as="li"
            variant={variant}
            color="muted-foreground"
            key={index}
          >
            {renderIcon(item.type)}
            {item.value}
          </JhText>
        );
      })}
    </ul>
  );
};
export { PerksDrawback };
export type { PerksDrawbackProps };
